import React, { useEffect, useState } from "react";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  Button,
  Card,
  Col,
  Row,
  Space,
  Table,
  Tag,
  Modal,
  Form,
  Input,
  Typography,
  Select,
  Switch,
  Grid,
  ConfigProvider,
} from "antd";
import axios from "axios";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Alert } from "antd";
import { _delete, _get, _put } from "../services/service_api";
import {
  API_BASE_URL,
  DELETE_USER,
  directToken,
  USER_LIST,
} from "../services/end_points";
import AddUser from "./AddUser";
import EditDoctor from "../Doctor/EditDoctor";
import EditUser from "./EditUser";
import { useRoleData } from "../Data/Roledata";
const { useBreakpoint } = Grid;

const UserManager = ({ handleRole }) => {
  const { column, rows } = useRoleData({ handleRole });
  const isAdmin = rows.some((row) => row.userType === "Admin");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [user, setUser] = useState([]);
  const [alert, setAlert] = useState(null);
  const [formdata, setFormData] = useState(null);
  const userId = localStorage.getItem("userid");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 8;
  const [selectedRecord, setSelectedRecord] = useState(null); // For editing user

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await _get(
        `${API_BASE_URL}${USER_LIST}${userId}`,
        directToken
      );
      if (response.data && response.data.list) {
        setUser(response.data.list);
        setFilteredUsers(response.data.list);
      } else {
        console.error("Response data is not as expected:", response.data);
      }
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  };

  const handleDelete = async (data) => {
    try {
      const response = await _delete(`${API_BASE_URL}${DELETE_USER}${data}`);
      setAlert({
        type: "success",
        message: response.data.message || "User Deleted!",
      });
      fetchData();
    } catch (error) {
      console.error("Error deleting user:", error);
      setAlert({
        type: "error",
        message: error.response?.data?.message || "Failed to delete user",
      });
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleOnChange = async (userid, checked) => {
    try {
      await _put(`${API_BASE_URL}/user/EditActive-user/${userid}`, {
        Active: checked ? 1 : 0,
      });
      fetchData();
    } catch (error) {
      console.error("Error updating user:", error.message);
    }
  };

  const handleEdit = (data) => {
    if (data) {
      setSelectedRecord(data); // Set the selected user record to state
      setIsModalVisible(true); // Show the modal
      setIsEditing(true); // Switch to edit mode
    } else {
      console.error("Invalid user data");
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    const filtered = user.filter((userItem) =>
      Object.values(userItem).some(
        (field) => field && field.toString().toLowerCase().includes(value)
      )
    );
    setFilteredUsers(filtered);
    setCurrentPage(1);
  };

  const paginatedData = filteredUsers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const columns = [
    {
      title: "S.No",

      // title: <span style={{ fontSize: "14px" }}>S.No</span>,
      dataIndex: "serialNumber",
      key: "serialNumber",
      // width: "50px",

      render: (_, __, index) => index + 1 + (currentPage - 1) * pageSize,
    },
    {
      title: "Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
    },
    ...(rows[0]?.id === 1
      ? [
          {
            title: "Active",
            dataIndex: "Active",
            key: "Active",
            render: (active, record) => (
              <Switch
                checked={active === 1}
                size="small"
                onChange={(checked) => handleOnChange(record.userid, checked)}
              />
            ),
          },
        ]
      : []),
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div>
          <Button
            size="small"
            style={{
              fontSize: "12px",
              padding: "4px 8px",
              border: "1px solid #0899f9",
              color: "#0899f9",
            }}
            onClick={() => handleEdit(record)} // Open modal for editing
          >
            <EditOutlined />
          </Button>
          {isAdmin && (
            <Button
              size="small"
              style={{
                fontSize: "12px",
                padding: "4px 10px",
                marginLeft: "5px",
                border: "1px solid #941717",
                color: "#941717",
              }}
              onClick={() => handleDelete(record.userid)} // Delete the user
            >
              <DeleteOutlined />
            </Button>
          )}
        </div>
      ),
    },
  ];

  const showModal = () => setIsModalVisible(true);
  const closeModal = () => {
    setIsModalVisible(false);
    setIsEditing(false);
  };

  const updateUserList = (newUser) => {
    setUser((prevUser) => {
      // Check if the user is being added or updated
      const index = prevUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    setFilteredUsers((prevFilteredUser) => {
      const index = prevFilteredUser.findIndex(
        (user) => user.userid === newUser.userid
      );
      if (index === -1) {
        // Add new user
        return [...prevFilteredUser, newUser];
      } else {
        // Update existing user
        const updatedUsers = [...prevFilteredUser];
        updatedUsers[index] = newUser;
        return updatedUsers;
      }
    });
    fetchData();
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Switch: {
            // colorPrimary: "#007e00d9",
            colorPrimary: "#22DD22",
            colorPrimaryHover: "red",
          },
        },
      }}
    >
      <DefaultLayout>
        <Card style={{ width: "100%", minHeight: "600px", height: "100%" }}>
          <Row
            gutter={[12, 12]}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Col xs={24} sm={6} md={4} lg={4} xl={4}>
              <h2>User List</h2>
            </Col>
            <Col xs={24} sm={8} md={12} lg={8} xl={8}>
              <Input
                placeholder="Search Users,Name,Email,UserType"
                style={{ width: "100%", maxWidth: "300px", height: "40px" }}
                onChange={handleSearch}
              />
            </Col>
            <Col xs={24} sm={8} md={4} lg={4} xl={4}>
              <Button
                style={{
                  // backgroundColor: "#feccdc",
                  // fontSize: "16px",
                  // color: "black",
                  // borderRadius: "10px",
                  backgroundColor: "#6499f1",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  width: "100%",
                  height: "48px",
                  maxWidth: "200px",
                }}
                onClick={showModal}
              >
                Create User
              </Button>
            </Col>
          </Row>

          <Table
            columns={columns}
            dataSource={paginatedData}
            rowKey="id"
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: filteredUsers.length,
              onChange: handlePageChange,
              showSizeChanger: false,
            }}
            // scroll={{ x: 1000 }}
            scroll={{ x: "max-content" }}
          />

          <Modal
            title={isEditing ? "Edit User" : "Add User"}
            visible={isModalVisible}
            onCancel={closeModal}
            footer={null}
          >
            {isEditing ? (
              <EditUser data={selectedRecord} />
            ) : (
              <AddUser updateUserList={updateUserList} />
            )}
          </Modal>
        </Card>
      </DefaultLayout>
    </ConfigProvider>
  );
};
export default UserManager;
